import { useAssets } from "@/queries/useAssets";
import { useSites } from "@/queries/useSites";
import { useStandards } from "@/queries/useStandards";
import type { Asset, AssignedProject, Site, Standard } from "@/types";

import { useAssignedProjects } from "./useAssignedProjects";

const EMPTY_SITES: Site[] = [];
const EMPTY_ASSETS: Asset[] = [];

interface UseFilterScopeDataParams {
  role: string;
  selectedProject: string;
  selectedSite: string;
}

export interface FilterScopeData {
  standardsData: Standard[] | undefined;
  assignedProjectsData: AssignedProject[] | undefined;
  sitesData: Site[];
  assetsData: Asset[];
}

export function useFilterScopeData({
  role,
  selectedProject,
  selectedSite,
}: UseFilterScopeDataParams): FilterScopeData {
  const { data: standardsData } = useStandards();
  const { data: assignedProjectsData } = useAssignedProjects({ role });
  const sitesData = useSites({ project_id: selectedProject }).data ?? EMPTY_SITES;
  const assetsData =
    useAssets({ site_id: selectedSite, project_id: selectedProject }).data ?? EMPTY_ASSETS;

  return { standardsData, assignedProjectsData, sitesData, assetsData };
}
